import { createFileRoute } from "@tanstack/react-router";
import MasServicios from "@/pages/MasServicios";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Más servicios", path: "/mas-servicios" }]);

export const Route = createFileRoute("/mas-servicios")({
  head: () => ({
    meta: [
      { title: "Servicios SEO y Marketing Digital | SEOEVOLUTION" },
      {
        name: "description",
        content:
          "Explora nuestra gama completa de servicios SEO y marketing digital. Desde posicionamiento web hasta desarrollo de tiendas online con IA.",
      },
      {
        name: "keywords",
        content: "servicios SEO, marketing digital, posicionamiento web, desarrollo web, ecommerce, WordPress, React",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/mas-servicios" },
      { property: "og:title", content: "Servicios SEO y Marketing Digital | SEOEVOLUTION" },
      {
        property: "og:description",
        content:
          "Explora nuestra gama completa de servicios SEO y marketing digital. Desde posicionamiento web hasta desarrollo de tiendas online con IA.",
      },
      { name: "twitter:title", content: "Servicios SEO y Marketing Digital | SEOEVOLUTION" },
      {
        name: "twitter:description",
        content:
          "Explora nuestra gama completa de servicios SEO y marketing digital. Desde posicionamiento web hasta desarrollo de tiendas online con IA.",
      },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/mas-servicios" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: MasServicios,
});
